import { useContext } from 'react';
import Context, { SprievodnyDokumentContextContent } from '../SprievodnyDokumentContext';

export default (): SprievodnyDokumentContextContent => useContext(Context);
